import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthentictionService } from '../../services/authentiction.service';
import { UtilService } from '../../services/util.service';
import { Constant } from '../../services/data';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild('ngOtpInput', { static: false }) ngOtpInputRef: any | undefined;
  public isLoading: boolean = false;
  public hidelogin:boolean =true
  public show: boolean = true;
  public user: any = {
    username: '',
    otp: '',
    rememberMe: false,
  };
  public registerUser: any = { firstName: '', lastName: '',email:'', password: '', confirmPassword: '' };

  public passwordTextType: boolean;
  public config: any = {
    length: 4, allowNumbersOnly: true, isPasswordInput: true, disableAutoFocus: true, inputStyles: {
      'margin': '0px 8px', 'background': '#000000',
      'color': 'white', 'font-size': '32px', 'outline': 'none'
    }
  };

  toggleOtp() {
    this.ngOtpInputRef.config.isPasswordInput = this.show;
    (this.show) ? (this.ngOtpInputRef.inputType = 'tel') : (this.ngOtpInputRef.inputType = 'password');
    // this.cdRef.detectChanges();
  }

  type: 'password' | 'text' = 'password'; // For login
  registerPasswordType: 'password' | 'text' = 'password'; // For register - password
  confirmPasswordType: 'password' | 'text' = 'password'; // For register - confirm password
  loginTab:boolean = true;
  registerTab:boolean = false;
  userid:any;
  isLogin:boolean = false;
  isPlaylist:boolean = false;

  constructor(
    private router: Router, private authService: AuthentictionService, private utilService: UtilService, private changed: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.isLogin = this.authService.isLogin();
    const UserData = this.utilService.getValueStorage(Constant.MTOKEN) || '';
    // if ( UserData !== '') {
    //   this.router.navigate(['/playlist']);
    // }
   
   }

  fillForm() {
    if (this.utilService.getValueCookie(Constant.ISREMEMBER_FULLKEY)) {
      this.user.username = this.utilService.getValueCookie(Constant.FULLUSERNAME_KEY);
      this.user.otp = this.utilService.getValueCookie(Constant.FULLPASSWORD_KEY);
      this.ngOtpInputRef.setValue(this.user.otp);
      this.changed.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    this.fillForm();
  }

  

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }
  onSubmit(form: NgForm) {
    if (form.valid) {
    this.isLoading = true;
    this.utilService.showSpinner()
    
    if(this.loginTab){
          let param: any = {
            userid: this.user.username,
            pwd: this.user.otp
          };
          
          this.authService.login(param).subscribe((res: any) => {
            this.isLoading = false;
            this.utilService.hideSpinner()
            console.log(res);
            
            if (res.status === 'success') // userid
            {
              this.utilService.saveValueCookie(Constant.USERTOKEN,res?.data?.token);
              this.utilService.saveValueUser(Constant.USERDATA,JSON.stringify(res.data.user))

              let data ={
                user_id : res.data.user.user_id,
                password:'purpleapp'
              }
              this.authService.loginMedia(data).subscribe((res:any) =>{
                console.log(res);
                if(res){
                  this.utilService.saveMediaToken(Constant.MTOKEN,res.access_token);
                  this.router.navigate(['/playlist'])
                }
              },(error:any)=>{
                if(error.status === 401){
                  this.authService.registerMedia(data).subscribe((res:any)=>{
                    if(res){
                      this.authService.loginMedia(data).subscribe((res:any)=>{
                        if(res){
                          console.log(res);
                          this.utilService.saveMediaToken(Constant.MTOKEN,res.access_token);
                        }
                      })
                    }
                  })
                  this.utilService.showErrorToast(error.error.msg)
                  console.log(error,'err');
                }
                
              })
            // if (res.xstream || res.m3u) {
            //     if (res.xstream){
            //     this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, res.xstream[0].userid);
            // }
            // else{
            //     this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, res.m3u[0].userid);
            //   }
            // }
            // if (this.user.rememberMe) {
            //   this.utilService.clearCookieStorage();
            //   this.utilService.saveValueCookie(Constant.ISREMEMBER_FULLKEY, true);
            //   this.utilService.saveValueCookie(Constant.FULLUSERNAME_KEY, this.user.username);
            //   this.authService.saveEncryptedPassword(this.user.otp);
              
            //   this.utilService.saveValueCookie(Constant.FULLPASSWORD_KEY, this.user.otp);
            // }
            // else {
            //   this.utilService.clearCookieStorage();
            // }
            
            // if (!res.xstream && !res.m3u) {
            //   this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, this.user.username);
            // }
            // this.router.navigate(['playlist'], { queryParams: { isRemember: this.user.rememberMe } });
            // this.utilService.showErrorSuccess('', "Login Succesfully.");
            
            }
          
        },(err: any) => {
          this.utilService.hideSpinner();
          this.isLoading = false;
          
            if(err.status === 400){
              console.log(err.error,'===> !');
              this.utilService.showErrorToast(err?.error.errors.email); // show the error 
            }else if(err.status === 401){
              console.log(err.error);
              this.utilService.showErrorToast(err.error.message); // show the error 
            }
            
        
        }
        
          
      )
      }
     

      }
    }

    onRegisterSubmit(form: NgForm) {
      if (form.invalid) {
        // Mark all controls as touched to show validation messages
        Object.keys(form.controls).forEach(field => {
          const control = form.controls[field];
          control.markAsTouched({ onlySelf: true });
        });
      return; // stop execution here if form is invalid
  }
// ✅ Check if passwords match
  if (this.registerUser.password !== this.registerUser.confirmPassword) {
    form.controls['confirmPassword'].setErrors({ mismatch: true });
    return;
  } else {
    form.controls['confirmPassword'].setErrors(null); // Clear previous error
  }
  // Proceed with form submission if valid
  this.isLoading = false;
  this.utilService.hideSpinner();

  const param = {
    firstname: this.registerUser.firstName,
    lastname: this.registerUser.lastName,
    email: this.registerUser.email,
    password: this.registerUser.password,
    confirmPwd: this.registerUser.confirmPassword
  };

  console.log('register form ==>', param);

  this.authService.register(param).subscribe({
    next: (res: any) => {
      if (res.status === true) {
        this.loginTab = true;
        this.registerTab = false;
        this.router.navigate(['/login']);
        this.utilService.showSuccess(res.message);
      }
    },
    error: (err) => {
      console.log('Full error:', err);

      if (err?.error?.errors) {
        const errors = err.error.errors;
        const firstKey = Object.keys(errors)[0];
        const message = errors[firstKey][0];
        this.utilService.showErrorToast(message);
      }

      this.loginTab = false;
      this.registerTab = true;
    }
  });
}


    onRegisterSubmits(form:NgForm){
       
      if(form.valid) {
        form.value.otp = true ;
        form.value.username = true;
        this.isLoading = false;
        this.utilService.hideSpinner()
        let param = {
          firstname: this.registerUser.firstName,
          lastname: this.registerUser.lastName,
          email:this.registerUser.email,
          password: this.registerUser.password,
          confirmPwd: this.registerUser.confirmPassword
        };
        console.log('register form ==>',param);
        this.authService.register(param).subscribe({
          next: (res: any) => {
            if (res.status == true) {
              this.loginTab = true;
              this.registerTab = false;
              this.router.navigate(['/login']);
              this.utilService.showSuccess(res.message)
            }
          },
          error: (err) => {
            console.log('Full error:', err);
        
            // You can access nested validation errors like:
            if (err?.error?.errors) {
              const errors = err.error.errors;
              const firstKey = Object.keys(errors)[0];
              const message = errors[firstKey][0];
              this.utilService.showErrorToast(message);
            } else {
              // Fallback generic message
              // this.utilService.showErrorToast(err?.error?.message || 'Something went wrong.');
            }
        
            this.loginTab = false;
            this.registerTab = true;
          }
        });
      }
        
    }

  saveEditPlaylist(){}

  otpChange(value: any) {
    this.user.otp = value;
  }
  rememberMe(event: any) {
    this.user.rememberMe = event.target.checked;
  }

  preventSpace(event: any) {
    if ((event.charCode == 32 || event.charCode == 64) && !event.target.value) {
      event.preventDefault();
    }
  }
  NumOnly(event: any) {
    let Numpattern = /^([0-9])*$/;
    let resultNum = Numpattern.test(event.key);
    return resultNum;

  }
  // hideShowPassword() {
  //   if (this.type === 'password') {
  //     this.type = 'text';
  //   } else {
  //     this.type = 'password';
  //   }
  // }
  
  hideShowPassword(): void {
    this.type = this.type === 'password' ? 'text' : 'password';
    console.log(typeof(this.type));
    
  }
  
  hideShowRegisterPassword(): void {
    this.registerPasswordType = this.registerPasswordType === 'password' ? 'text' : 'password';
    console.log(typeof(this.registerPasswordType));
    
  }
  
  hideShowConfirmPassword(): void {
    this.confirmPasswordType = this.confirmPasswordType === 'password' ? 'text' : 'password';
    console.log(this.confirmPasswordType);
    
  }
  switchTab(mode:string){
    console.log(mode);
    if(mode === 'register'){
      this.registerTab = true;
      this.loginTab= false;
       // Clear login form values
    this.user = {
      username: '',
      otp: ''
    };
      
    }else{
      this.loginTab = true;
      this.registerTab = false;
      // Clear register form values
    this.registerUser = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: ''
    };
    }
  }

  skip(){
  this.isPlaylist = this.authService.isPlayList();
    if(this.isPlaylist == true){
      this.router.navigate(['/playlist'])
    }else{
      this.router.navigate(['/add-playlist'])
    }
  }
  

}
